module.exports = __webpack_public_path__ + "static/img/produce17.855efc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce17.png
// module id = 147
// module chunks = 4